const DOCS_BASE_URL = process.env.VUE_APP_DOCS_BASE_URL

/**
 * Generates the URL used to access an unryo documentation.
 *
 * @param topic The documentation topic path.
 * @param section Specific section to add.
 * @returns The URL that points to the integration documentation.
 */
export function docsUrl (topic: string, section?: string) {
  let url = `${DOCS_BASE_URL}topics/${topic}.html`
  if (section) {
    url += `#${section}`
  }
  return url
}
